import { useEffect, useState } from "react";
import { tabs } from "@/data/content";

const DEFAULT_TAB = "telegram";
const VALID_TABS = tabs.map((t) => t.id);

const readHashTab = () => {
  const hash = window.location.hash.slice(1);
  return VALID_TABS.includes(hash) ? hash : DEFAULT_TAB;
};

export const useHashTab = () => {
  const [activeTab, setActiveTab] = useState(readHashTab);

  useEffect(() => {
    const onHashChange = () => setActiveTab(readHashTab());
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  const changeTab = (tabId) => {
    setActiveTab(tabId);
    window.history.pushState(null, "", `#${tabId}`);
  };

  return [activeTab, changeTab];
};
